import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../Helpers";
import {deserializePatientSurvey, PatientSurvey} from "../Survey";
import {Question} from "../../Survey";

interface SimpleAnswerable extends DeserializedRecord<'simple'> {
  points: number;
}

interface SliderAnswerable extends DeserializedRecord<'slider'> {
  startValue: number;
  endValue: number;
}

type AnswerQuestion = Omit<Question, "answer" | "answers">;

interface Answer extends DeserializedRecord {
  answerable?: SimpleAnswerable | SliderAnswerable;
  value: string;
  surveyQuestion: AnswerQuestion;
}

interface Session extends DeserializedRecord<"session"> {
  answers: Answer[];
  isDraft: boolean;
  author: DeserializedRecord;
  patientSurvey: PatientSurvey;
  points: number;
  score: number;
}

interface AnswerData extends JSONAPIRecord {
  relationships: {
    answerable: JSONAPISingleRelationship;
    survey_question: JSONAPISingleRelationship;
  }
}

const deserializeAnswer: Deserializer<Answer, AnswerData> = (data, included) => {
  const answerable = deserializeSingleRelationship<SimpleAnswerable | SliderAnswerable>(data.relationships.answerable, included);
  const surveyQuestion = deserializeSingleRelationship<AnswerQuestion>(data.relationships.survey_question, included);

  return {
    ...deserializeItem(data),
    answerable,
    surveyQuestion
  };
};

interface SessionData extends JSONAPIRecord {
  relationships: {
    answers: JSONAPIManyRelationship;
    author: JSONAPISingleRelationship;
    patient_survey: JSONAPISingleRelationship;
  }
}

const deserializeSession: Deserializer<Session, SessionData> = (data, included) => {
  const answers = deserializeManyRelationship(data.relationships.answers, included, deserializeAnswer);
  const author = deserializeSingleRelationship(data.relationships.author, included);
  const patientSurvey = deserializeSingleRelationship(data.relationships.patient_survey, included, deserializePatientSurvey);

  return {
    ...deserializeItem(data),
    answers,
    author,
    patientSurvey
  };
};

export {
  Answer as PatientSurveySessionAnswer,
  deserializeSession as deserializePatientSurveySession,
  Session as PatientSurveySession
};
